import React from "react";

export default function StudentHeader() {
  return <div>Student Header</div>;
}
